@import './pk-collapse.variables';

.collapse__content {
  @include transition(#{grid-template-rows, opacity});

  @apply grid opacity-0;
  grid-template-rows: 0fr;

  &.expand {
    @apply opacity-100;
    grid-template-rows: 1fr;

    .collapse__content-wrap {
      @apply animate-expand-collapse;
    }
  }
}

.collapse__button {
  @apply inline-block;

  &.align-center {
    @apply justify-center;
  }

  &.align-right {
    @apply justify-end;
  }

  &::part(button) {
    @apply mt-l flex w-auto cursor-pointer select-none items-center;
    @apply text-[length:--collapse--font-size-button] leading-l text-[color:--collapse--color-button];

    font-family: var(--collapse--font-family-button);
  }
}

.collapse__button--icon {
  @apply [--pk-icon--color:--collapse--color-button];

  @apply rotate-0 transition-transform duration-[25ms] ease-in-out;

  &.expand {
    @apply rotate-180;
  }
}
